import { Grid } from "@mui/material";
import SkeletonInput from "./SkeletonInput";
import SkeletonTitle from "./SkeletonTitle";
import type { ReactNode } from "react";

function SkeletonFormComplement(): ReactNode {
  return (
    <Grid container rowSpacing={1} columnSpacing={3}>
      <SkeletonInput />
      <SkeletonTitle />
      <SkeletonInput />
      <SkeletonTitle />
      <SkeletonInput />
      <SkeletonInput />
      <SkeletonInput />
      <Grid container size={{ md: 6 }}>
        <SkeletonInput />
      </Grid>
      <Grid container size={{ md: 6 }}>
        <SkeletonInput />
      </Grid>
      <SkeletonTitle />
      <Grid container size={{ md: 6 }}>
        <SkeletonInput />
      </Grid>
      <Grid container size={{ md: 6 }}>
        <SkeletonInput />
      </Grid>
    </Grid>
  );
}

export default SkeletonFormComplement;
